module.exports = __webpack_public_path__ + "static/img/bg_theme_pink@2x.1909924.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_pink@2x.png
// module id = rsbz
// module chunks = 1